import { ImageEffect } from './image-effect.model';

export class ImageWithEffects {
  image: string = '';
  effects: Array<ImageEffect> = [];
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/image-with-effects.model.ts